import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowThroughLineDown = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 12L12 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 2L12 22L12 21.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M7 17L12 22L17 17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M16 12L22 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconArrowThroughLineDown.js.map